/**
 * @generated SignedSource<<5347b57867cc2e65b2f48deb03446e1c>>
 * @relayHash 966fac3b021c46fc37e25098c8a1cc51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 53477b8f0f18b36ae74d207bd30302e223bfafe7c6963ec1f1d1a5241713937a

import type { ConcreteRequest } from 'relay-runtime';
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type ApprovalActivityHistoryQuery$variables = {
  after?: string | null;
  cloudId: string;
  contentId: string;
  contentStatuses: ReadonlyArray<GraphQLContentStatus | null>;
  first?: number | null;
};
export type ApprovalActivityHistoryQuery$data = {
  readonly confluence_workflowApplicationHistory: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly action: string;
        readonly actor: {
          readonly accountId: string | null;
          readonly displayName: string | null;
          readonly user: {
            readonly photos: ReadonlyArray<{
              readonly value: string | null;
            } | null> | null;
          } | null;
        } | null;
        readonly contentId: string;
        readonly contentStatus: GraphQLContentStatus;
        readonly contentVersion: number | null;
        readonly creationDate: {
          readonly value: string;
        };
        readonly id: string;
        readonly reviewDecision: {
          readonly comment: string | null;
          readonly decisionStatus: string | null;
        } | null;
        readonly targetPrincipal: {
          readonly principalId: string | null;
          readonly principalType: string | null;
        } | null;
        readonly triggerSource: string | null;
        readonly workflowApplicationId: string;
        readonly workflowReviewId: string | null;
        readonly workflowStatus: {
          readonly allowsReviews: boolean | null;
          readonly displayProperties: {
            readonly color: string | null;
            readonly description: string | null;
            readonly icon: string | null;
            readonly name: string | null;
          } | null;
          readonly id: string | null;
        } | null;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
};
export type ApprovalActivityHistoryQuery = {
  response: ApprovalActivityHistoryQuery$data;
  variables: ApprovalActivityHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatuses"
},
v4 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "contentStatuses",
    "variableName": "contentStatuses"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "workflowApplicationId"
},
v9 = {
  "kind": "ScalarField",
  "name": "workflowReviewId"
},
v10 = {
  "kind": "ScalarField",
  "name": "contentId"
},
v11 = {
  "kind": "ScalarField",
  "name": "contentVersion"
},
v12 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v13 = {
  "kind": "ScalarField",
  "name": "action"
},
v14 = {
  "kind": "ScalarField",
  "name": "triggerSource"
},
v15 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v16 = {
  "concreteType": "ConfluenceApprovalsDate",
  "kind": "LinkedField",
  "name": "creationDate",
  "plural": false,
  "selections": (v15/*: any*/)
},
v17 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v18 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v19 = {
  "concreteType": "AtlassianUserPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": (v15/*: any*/)
},
v20 = {
  "concreteType": "ConfluenceWorkflowApplicationHistoryTargetPrincipal",
  "kind": "LinkedField",
  "name": "targetPrincipal",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "principalType"
    },
    {
      "kind": "ScalarField",
      "name": "principalId"
    }
  ]
},
v21 = {
  "concreteType": "ConfluenceWorkflowApplicationHistoryReviewDecision",
  "kind": "LinkedField",
  "name": "reviewDecision",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "decisionStatus"
    },
    {
      "kind": "ScalarField",
      "name": "comment"
    }
  ]
},
v22 = {
  "concreteType": "ConfluenceApprovalsWorkflowStatus",
  "kind": "LinkedField",
  "name": "workflowStatus",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "allowsReviews"
    },
    {
      "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
      "kind": "LinkedField",
      "name": "displayProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        },
        {
          "kind": "ScalarField",
          "name": "icon"
        }
      ]
    }
  ]
},
v23 = {
  "concreteType": "ConfluencePageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ApprovalActivityHistoryQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationHistoryConnection",
        "kind": "LinkedField",
        "name": "confluence_workflowApplicationHistory",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceWorkflowApplicationHistoryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "concreteType": "ConfluenceWorkflowApplicationHistoryEntry",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/),
                  {
                    "concreteType": "ConfluenceWorkflowApplicationHistoryActor",
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/)
                ]
              }
            ]
          },
          (v23/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ApprovalActivityHistoryQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationHistoryConnection",
        "kind": "LinkedField",
        "name": "confluence_workflowApplicationHistory",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceWorkflowApplicationHistoryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "concreteType": "ConfluenceWorkflowApplicationHistoryEntry",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/),
                  {
                    "concreteType": "ConfluenceWorkflowApplicationHistoryActor",
                    "kind": "LinkedField",
                    "name": "actor",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/)
                ]
              }
            ]
          },
          (v23/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "966fac3b021c46fc37e25098c8a1cc51",
    "id": "53477b8f0f18b36ae74d207bd30302e223bfafe7c6963ec1f1d1a5241713937a",
    "metadata": {},
    "name": "ApprovalActivityHistoryQuery",
    "operationKind": "query",
    "text": "query ApprovalActivityHistoryQuery($cloudId:ID!,$contentId:ID!,$first:Int=20,$after:String,$contentStatuses:[GraphQLContentStatus]!){confluence_workflowApplicationHistory(cloudId:$cloudId,contentId:$contentId,first:$first,after:$after,contentStatuses:$contentStatuses){edges{cursor,node{id,workflowApplicationId,workflowReviewId,contentId,contentVersion,contentStatus,action,triggerSource,creationDate{value},actor{accountId,displayName,user{photos{value},id}},targetPrincipal{principalType,principalId},reviewDecision{decisionStatus,comment},workflowStatus{id,allowsReviews,displayProperties{name,description,color,icon}}}},pageInfo{endCursor,hasNextPage}}}"
  }
};
})();

(node as any).hash = "6262dd36ae19d8eb1fa847239b02b16b";

export default node;
